import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';

export const DutyDate = types.compose(
  BaseEntity,
  types.model('DutyDate', {
    dutyDateId: types.identifierNumber,
    date: types.string,
  }),
);
